import React from "react";
import { NavLink } from "react-router-dom";
import { Home, Compass, Briefcase, MessageCircle, User } from "lucide-react";
import { useI18n } from "../lib/i18n";

const items = [
  { to: "/app", icon: Home, key: "home", testid: "nav-home" },
  { to: "/discover", icon: Compass, key: "discover", testid: "nav-discover" },
  { to: "/campaigns", icon: Briefcase, key: "campaigns", testid: "nav-campaigns" },
  { to: "/messages", icon: MessageCircle, key: "messages", testid: "nav-messages" },
  { to: "/profile", icon: User, key: "profile", testid: "nav-profile" },
];

export function BottomNav() {
  const { t } = useI18n();
  return (
    <nav
      className="fixed bottom-0 inset-x-0 z-50 glass border-t border-cardline px-3 pb-[max(0.5rem,env(safe-area-inset-bottom))] pt-2"
      data-testid="bottom-nav"
    >
      <div className="mx-auto flex max-w-md items-center justify-around">
        {items.map(({ to, icon: Icon, key, testid }) => (
          <NavLink
            key={key}
            to={to}
            data-testid={testid}
            className={({ isActive }) =>
              `flex flex-col items-center gap-1 rounded-xl px-3 py-1.5 text-[11px] font-medium transition-colors ${
                isActive ? "text-gold" : "text-slate-400 hover:text-slate-200"
              }`
            }
          >
            {({ isActive }) => (
              <>
                <Icon size={22} strokeWidth={isActive ? 2.4 : 1.8} />
                <span>{t(key)}</span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
